<script>
  import { fly } from 'svelte/transition'
  import { onMount } from 'svelte'

  let show
  onMount(()=> {
    show = true
  })
</script>

{#if show}
<div in:fly={{ y: 20, delay: 500 }} out:fly={{ y: 20 }} class="bottom-card-outer">
  <div class="bottom-card-inner">
    <slot />
  </div>
</div>
{/if}


<style>
  .bottom-card-outer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 999;
  }
  .bottom-card-inner {
    display: flex;
    align-items: center;
    max-width: 420px;
		margin: 0 auto;
		padding: 0 1rem;
    background: #fff;
    padding: .5rem;
    border-radius: 1rem 1rem 0 0;
    justify-content: flex-end;
    box-shadow: 0px -1px 4px 0px #00000047;
  }
</style>